import logo from "./assets/logo.svg";
import "./App.css";
import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  opacity: ${(props) => (props.active ? 1 : 0)};
  transition: opacity 1s ease-in-out;
`;

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 20px;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const Logo = styled.img`
  width: 150px;
  margin-bottom: 2rem;
  animation: ${float} 6s ease-in-out infinite;

  @media (max-width: 768px) {
    width: 120px;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 480px) {
    width: 100px;
    margin-bottom: 1rem;
  }
`;

const scaleAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const Title = styled.h1`
  font-family: "Cormorant Garamond", serif;
  font-size: 6.5rem;
  color: #1a1714;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 400;
  letter-spacing: 4px;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
  animation: ${fadeIn} 2.5s ease-in, ${scaleAnimation} 8s ease-in-out infinite;
  transform-origin: center;

  @media (max-width: 768px) {
    font-size: 4rem;
    letter-spacing: 2px;
    margin-bottom: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 2.5rem;
    letter-spacing: 1px;
  }
`;

const Subtitle = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 1.5rem;
  color: #2d2925;
  text-align: center;
  max-width: 600px;
  line-height: 1.8;
  margin-bottom: 2rem;
  letter-spacing: 2px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
  animation: ${fadeIn} 3s ease-in, ${scaleAnimation} 8s ease-in-out infinite;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 1.2rem;
    line-height: 1.6;
    letter-spacing: 1px;
    max-width: 90%;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    line-height: 1.4;
    margin-bottom: 1.5rem;
  }
`;

const DecorativeElement = styled.div`
  width: 100px;
  height: 1px;
  background-color: #bcb8b1;
  margin: 2rem 0;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

function App() {
  const [currentBg, setCurrentBg] = useState(0);
  const backgrounds = [
    require("./assets/bg.jpeg"),
    require("./assets/bg2.jpeg"),
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBg((current) => (current + 1) % backgrounds.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [backgrounds.length]);

  return (
    <Container>
      {backgrounds.map((bg, index) => (
        <BackgroundImage key={bg} image={bg} active={currentBg === index} />
      ))}
      <ContentWrapper>
        <Logo src={logo} alt="Anointed Home" />
        <DecorativeElement />
        <Title>ANOINTED HOME</Title>
        <Subtitle>
          A curated collection of luxury home fragrances and essentials, coming
          soon.
        </Subtitle>
        <DecorativeElement />
      </ContentWrapper>
    </Container>
  );
}

export default App;
